export default __webpack_public_path__ + "static/media/dino.e40c9762.png";